import React from 'react';
import PropTypes from 'prop-types';
import {Tooltip} from '@mui/material';

const InfoTooltip = ({title}) => (
    <Tooltip title={title}>
        <span style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '16px',
            height: '16px',
            borderRadius: '50%',
            border: '1px solid currentColor',
            fontSize: '11px',
            lineHeight: 1,
            cursor: 'help',
        }}>i</span>
    </Tooltip>
);

InfoTooltip.propTypes = {
    title: PropTypes.node.isRequired,
};

export default InfoTooltip;
